import { render, staticRenderFns } from "./BaseDocumentIcon.vue?vue&type=template&id=7547d780"
import script from "./BaseDocumentIcon.vue?vue&type=script&lang=js"
export * from "./BaseDocumentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports